
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
export default {
  components: { VueSlickCarousel },
  data() {
    return {
      images: [],
      activeImage: null,
      activeImageIndex: 0,
      imageModalOpen: false,

      includedServices: [
        {
          name: this.$t("text.cleaningIncluded"),
          icon: "/images/cleaning.svg",
        },
        {
          name: this.$t("text.overheadIncluded"),
          icon: "/images/money.svg",
        },
      ],

      settings: {
        autoplay: true,
        speed: 1000,
        infinite: true,
        slidesToShow: 1,
        arrows: true,
        dots: false,
        centerMode: true,
        centerPadding: "360px",
        responsive: [
          {
            breakpoint: 1240,
            settings: {
              slidesToShow: 1,
              centerPadding: "180px",
            },
          },
          {
            breakpoint: 980,
            settings: {
              slidesToShow: 1,
              centerPadding: "90px",
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: false,
            },
          },
        ],
      },
    };
  },

  methods: {
    openImage(image, index) {
      this.activeImage = image;
      this.activeImageIndex = index;
      this.imageModalOpen = true;
    },
    closeImageModal() {
      this.imageModalOpen = false;
    },
  },
};
